<script lang="ts">
	import { onMount } from 'svelte';

	export let Title = 'Error';
	export let DefaultTitle = 'Error';
	export let Msg = 'Modal.Msg';
	export let shown = false;
	export let onClose: () => void = () => {};
	//generate random GUID for ID
	export const id: string =
		Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
	let refStr = '';
	let modelObj;
	let modelEl: HTMLDivElement;
	onMount(async () => {
		//const mdb = await import('mdb-ui-kit');
		const { Modal } = await import('mdb-ui-kit');
		modelObj = new Modal(modelEl, {
			keyboard: false,
			backdrop: 'static'
		});
	});
	export function Hide() {
		if (onClose) {
			onClose();
		}
		modelObj.hide();
		Title = DefaultTitle;
		refStr = '';
		shown = false;
	}
	export function SetTmpTitle(title: string) {
		Title = title;
	}
	export function SetRefStr(str: string) {
		refStr = str;
	}
	export function Show(msg: string) {
		// show embedded modal if embedded
		if (msg) {
			Msg = msg;
		}
		modelObj.show();
		shown = false;
	}
</script>

<!-- {#if shown} -->
<div
	class="modal fade"
	{id}
	tabindex="-1"
	aria-labelledby="errorModalLabel"
	aria-hidden="true"
	bind:this={modelEl}
	role="dialog"
>
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="errorModalLabel">{Title}</h5>
				<button
					class="btn-close"
					id="errorModelClose"
					type="button"
					data-bs-dismiss="modal"
					on:click={Hide}
					aria-label="Close"
				/>
			</div>
			<div class="modal-body">
				<p id="modal_errorMsg">{@html Msg}</p>
			</div>
			<div class="modal-footer d-flex justify-content-between">
				<div class="d-flex">
					{#if refStr}Reference #: {refStr}{/if}
				</div>
				<div class="d-flex">
					<button
						class="btn btn-primary"
						id="errorModelConfirm"
						type="button"
						data-bs-dismiss="modal"
						on:click={Hide}>Confirm</button
					>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- {/if} -->
